import styles from './Select.module.scss';
import { Select as AntSelect } from 'antd';
import React, { forwardRef } from 'react';

const { Option } = AntSelect;

const Select = forwardRef(function Select(
  { placeholder, className = '', options = [], ...props },
  ref
) {
  return (
    <AntSelect
      ref={ref}
      rootClassName={`${styles.input} ${className}`}
      placeholder={placeholder}
      showSearch
      allowClear
      {...props}
    >
      {options.map(({ value, label }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </AntSelect>
  );
});

export default Select;